<div class="h-full flex flex-col overflow-hidden p-sm">
  <!-- Header Section -->
  <app-dialog-header title="recentDownloads" (close)="onClose()">
    @if (downloads().length > 0) {
    <app-text-button
      [label]="'clearAll' | translate"
      (clicked)="clearAll()"
      styleClass="!p-0 !text-xs !font-semibold"
    ></app-text-button>
    }
  </app-dialog-header>

  <!-- Content Section -->
  <div class="popup-scroll-content flex-1 overflow-y-auto py-sm">
    @if (downloads().length === 0) {
    <div
      class="flex flex-col items-center justify-center text-center opacity-60 h-full"
    >
      <ic-download
        [width]="48"
        [height]="48"
        startColor="var(--color-gray-text)"
        endColor="var(--color-gray-text)"
        [opacity]="0.2"
      ></ic-download>
      <p class="mt-sm text-sm font-medium text-gray-text">
        {{ 'noRecentDownloads' | translate }}
      </p>
    </div>
    } @else {
    <div class="flex flex-col gap-sm">
      @for (item of downloads(); track item.id) {
      <app-card appClickable
        [styleClass]="
          'p-sm hover:bg-soft-bg transition-all duration-200 cursor-pointer border border-transparent hover:border-line/50 group relative'
        "
        (click)="onOpenFolder(item)"
      >
        <div class="flex items-center gap-sm">
          <!-- Details -->
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-sm">
              <p
                class="text-sm font-semibold text-dark-text truncate pr-sm"
                [title]="item.filename"
              >
                {{ item.filename }}
              </p>
            </div>
            <div class="flex items-center gap-xs mt-0.5">
              <span
                class="text-[10px] font-bold uppercase tracking-wider text-gray-text/60"
              >
                {{ item.type | translate }}
              </span>
              <span class="text-[10px] text-gray-text/40">•</span>
              <span class="text-[10px] font-medium text-gray-text/60">
                {{ formatDate(item.timestamp) }}
              </span>
            </div>
          </div>

          <!-- Action Icon -->
          <div
            class="w-8 h-8 rounded-full flex items-center justify-center text-primary group-hover:scale-110 transition-transform"
          >
            <i class="pi pi-download text-lg"></i>
          </div>
        </div>
      </app-card>
      }
    </div>
    }
  </div>
</div>
